import {
  WSActions,
  WSButton,
  WSElement,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { useCallback, useMemo } from "react";
import { BulkReviewProps } from "../../types";
import { Row } from "../Row";
import styles from "./index.module.scss";

export const BulkReviewPanel: React.FC<BulkReviewProps<any>> = props => {
  const activeIndex = useMemo(() => {
    return props.rows.findIndex(row => row.id === props.activeId);
  }, [props.activeId, props.rows]);

  const isPrevActive = useMemo(() => {
    return activeIndex > 0;
  }, [activeIndex]);

  const isNextActive = useMemo(() => {
    return activeIndex < props.rows.length - 1;
  }, [activeIndex, props.rows]);

  const onPrev = useCallback(() => {
    props.onRowClick(props.rows[activeIndex - 1]);
  }, [props, activeIndex]);

  const onNext = useCallback(() => {
    props.onRowClick(props.rows[activeIndex + 1]);
  }, [props, activeIndex]);

  const activeRow = useMemo(() => {
    return props.rows[activeIndex];
  }, [activeIndex, props.rows]);

  return (
    <WSElement className={styles.container}>
      <WSElement className={styles.header}>
        <WSElement className={styles.title}>
          <WSText weight="medium" singleLine>
            Filtered view
          </WSText>
          <WSButton.Link
            label="Close"
            rightIcon="exit"
            onClick={props.onClose}
          />
        </WSElement>

        <WSElement className={styles.actions}>
          <WSElement className={styles.listSize}>
            <WSText.ParagraphSm color="gray500" singleLine>
              {props.listSize} items
            </WSText.ParagraphSm>
          </WSElement>

          <WSActions
            buttons={[
              {
                label: "Prev",
                icon: "caret-left",
                kind: "Secondary",
                disabled: !isPrevActive,
                onClick: onPrev
              },
              {
                label: "Next",
                rightIcon: "caret-right",
                kind: "Secondary",
                disabled: !isNextActive,
                onClick: onNext
              }
            ]}
          />
        </WSElement>
      </WSElement>

      <WSElement className={styles.activeRow}>
        <WSText.ParagraphSm color="gray500">Now viewing:</WSText.ParagraphSm>
        <Row {...activeRow} />
      </WSElement>
    </WSElement>
  );
};
